import React, { createContext, useReducer } from 'react';
import { getAdminSession, isDashboardAdmin } from '../utils/adminSession';

export const AdminContext = createContext();

const initialState = {
  adminInfo: getAdminSession(),
};

function reducer(state, action) {
  switch (action.type) {
    case 'USER_LOGIN':
      return {
        ...state,
        adminInfo: isDashboardAdmin(action.payload) ? action.payload : null,
      };

    case 'USER_LOGOUT':
      return {
        ...state,
        adminInfo: null,
      };

    default:
      return state;
  }
}

export const AdminProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };
  return (
    <AdminContext.Provider value={value}>{children}</AdminContext.Provider>
  );
};
